import React from 'react';

import type { InventoryAgeingRow } from '../../api/inventory';
import { semanticColors } from '@styles/design-system';
import { dataSheetTokens } from '../ui/DataSheet';

/** Share of a SKU's stock that is past the over-threshold age, toned by how much of it there is. */
export const SharePill: React.FC<{ share: number }> = ({ share }) => {
    const tone =
        share >= 60 ? semanticColors.critical : share >= 25 ? semanticColors.warning : semanticColors.positive;
    return (
        <span
            style={{
                display: 'inline-block',
                padding: '2px 8px',
                borderRadius: 999,
                fontSize: 11,
                fontWeight: 600,
                background: tone.light,
                color: tone.dark,
            }}
        >
            {share}%
        </span>
    );
};

export const GroupCell: React.FC<{ row: InventoryAgeingRow }> = ({ row }) => (
    <span style={{ display: 'inline-flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 600 }}>{row.sku}</span>
        <span style={{ fontSize: 11, color: dataSheetTokens.colors.textMuted }}>
            {row.skuCount ?? 0} SKU{(row.skuCount ?? 0) === 1 ? '' : 's'}
        </span>
    </span>
);
